import React, { useEffect, useState } from "react";
import { SlidersHorizontal } from "lucide-react";
import { toast } from "sonner";
import { Switch } from "../../components/ui/switch";
import { api } from "../../lib/api";

const FEATURES = [
  ["edit", "Edit messages", "Customers can edit their own text messages within 15 minutes"],
  ["delete", "Delete messages", "Customers can delete their own messages"],
  ["reactions", "Reactions", "Emoji reactions on messages"],
  ["reply", "Reply", "Reply to a specific message"],
  ["media", "Photos & videos", "Send photos and videos from the gallery, or paste screenshots"],
  ["documents", "Documents", "Send PDF, Word, Excel and other files"],
  ["camera", "Camera", "Take a photo or record a video right in the chat"],
  ["voice", "Voice notes", "Hold the mic to send a voice message"],
  ["typing", "Typing indicator", "Show \"Tanya is typing…\" to customers"],
  ["receipts", "Read receipts", "Show customers \"Sent\" and \"Seen\" ticks"],
];

export const ChatFeaturesCard = () => {
  const [f, setF] = useState(null);
  useEffect(() => { api.get("/content").then((r) => setF(r.data.chat_features || {})); }, []);
  const toggle = async (k, v) => {
    const next = { ...f, [k]: v };
    setF(next);
    try { await api.put("/content", { chat_features: next }); toast.success(`${FEATURES.find((x) => x[0] === k)[1]} ${v ? "turned on" : "turned off"}`); }
    catch { setF(f); toast.error("Could not save. Please try again."); }
  };
  return (
    <div className="space-y-4 rounded-2xl border border-[#e3f0ed] bg-white p-6" data-testid="chat-features-card">
      <div className="flex items-center gap-2"><SlidersHorizontal size={18} className="text-[#0e8c7f]" /><h3 className="text-[18px] font-bold">Chat features</h3></div>
      <p className="text-[14px] text-[#5b6d6a]">Choose what customers can do in the live chat. Changes apply right away.</p>
      <div className="divide-y divide-[#eef5f3]">
        {FEATURES.map(([k, label, desc]) => (
          <label key={k} className="flex items-center justify-between gap-4 py-3">
            <span className="min-w-0"><span className="block text-[14.5px] font-semibold text-[#0f2e2a]">{label}</span><span className="block text-[12.5px] text-[#6b7c79]">{desc}</span></span>
            <Switch checked={f ? f[k] !== false : true} disabled={!f} onCheckedChange={(v) => toggle(k, v)} data-testid={`feature-switch-${k}`} />
          </label>
        ))}
      </div>
    </div>
  );
};
